<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'b2b-table-menu-borradores',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      'isShowServicioBorrador',
      'isShowCompradorBorrador',
      'isShowCentroCompradorBorrador',
      'isShowCentroEntregaBorrador',
      'isShowCentroFacturadoBorrador',
      'isShowVendedorBorrador',
      'isShowFechaEmisionBorrador',
      'isShowNumeroFacturaBorrador',
      'isShowFechaOperacionBorrador',
      'isShowFechaRegistroBorrador',
      'isShowTotalPagarBorrador',
      'isShowTotalEjecutableBorrador',
      'isShowDivisaBorrador',
      'optionsFilterService',
      'canViewDistributionCentres'
    ])
  },
  methods: {
    ...mapActions([
      'isShowServicioBorradorAction',
      'isShowCompradorBorradorAction',
      'isShowCentroCompradorBorradorAction',
      'isShowCentroEntregaBorradorAction',
      'isShowCentroFacturadoBorradorAction',
      'isShowVendedorBorradorAction',
      'isShowFechaEmisionBorradorAction',
      'isShowNumeroFacturaBorradorAction',
      'isShowFechaOperacionBorradorAction',
      'isShowFechaRegistroBorradorAction',
      'isShowTotalPagarBorradorAction',
      'isShowTotalEjecutableBorradorAction',
      'isShowDivisaBorradorAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'servicio':
          isShow = !this.isShowServicioBorrador
          this.isShowServicioBorradorAction(isShow)
          break
        case 'comprador':
          isShow = !this.isShowCompradorBorrador
          this.isShowCompradorBorradorAction(isShow)
          break
        case 'centro-comprador':
          isShow = !this.isShowCentroCompradorBorrador
          this.isShowCentroCompradorBorradorAction(isShow)
          break
        case 'centro-entrega':
          isShow = !this.isShowCentroEntregaBorrador
          this.isShowCentroEntregaBorradorAction(isShow)
          break
        case 'centro-facturado':
          isShow = !this.isShowCentroFacturadoBorrador
          this.isShowCentroFacturadoBorradorAction(isShow)
          break
        case 'vendedor':
          isShow = !this.isShowVendedorBorrador
          this.isShowVendedorBorradorAction(isShow)
          break
        case 'fecha-emision':
          isShow = !this.isShowFechaEmisionBorrador
          this.isShowFechaEmisionBorradorAction(isShow)
          break
        case 'num-factura':
          isShow = !this.isShowNumeroFacturaBorrador
          this.isShowNumeroFacturaBorradorAction(isShow)
          break
        case 'fecha-operacion':
          isShow = !this.isShowFechaOperacionBorrador
          this.isShowFechaOperacionBorradorAction(isShow)
          break
        case 'fecha-registro':
          isShow = !this.isShowFechaRegistroBorrador
          this.isShowFechaRegistroBorradorAction(isShow)
          break
        case 'total-pagar':
          isShow = !this.isShowTotalPagarBorrador
          this.isShowTotalPagarBorradorAction(isShow)
          break
        case 'total-ejecutable':
          isShow = !this.isShowTotalEjecutableBorrador
          this.isShowTotalEjecutableBorradorAction(isShow)
          break
        case 'divisa':
          isShow = !this.isShowDivisaBorrador
          this.isShowDivisaBorradorAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      if (this.canViewDistributionCentres) {
        this.columns = [
          {
            text: this.$t('drafts.drafts_entity_table.project'), value: 'servicio', show: this.isShowServicioBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.buyer'), value: 'comprador', show: this.isShowCompradorBorrador
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer_centre'), value: 'centro-comprador', show: this.isShowCentroCompradorBorrador
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer_delivery_centre'), value: 'centro-entrega', show: this.isShowCentroEntregaBorrador
          }, {
            text: this.$t('invoices.invoices_entity_table.buyer_invoicee_centre'), value: 'centro-facturado', show: this.isShowCentroFacturadoBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.seller'), value: 'vendedor', show: this.isShowVendedorBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.issue_date'), value: 'fecha-emision', show: this.isShowFechaEmisionBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.invoice_number'), value: 'num-factura', show: this.isShowNumeroFacturaBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.operation_date'), value: 'fecha-operacion', show: this.isShowFechaOperacionBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.creation_date'), value: 'fecha-registro', show: this.isShowFechaRegistroBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.total_outstanding_amount'), value: 'total-pagar', show: this.isShowTotalPagarBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.total_executable_amount'), value: 'total-ejecutable', show: this.isShowTotalEjecutableBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.currency'), value: 'divisa', show: this.isShowDivisaBorrador
          }
        ]
      } else {
        this.columns = [
          {
            text: this.$t('drafts.drafts_entity_table.project'), value: 'servicio', show: this.isShowServicioBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.buyer'), value: 'comprador', show: this.isShowCompradorBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.seller'), value: 'vendedor', show: this.isShowVendedorBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.issue_date'), value: 'fecha-emision', show: this.isShowFechaEmisionBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.invoice_number'), value: 'num-factura', show: this.isShowNumeroFacturaBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.operation_date'), value: 'fecha-operacion', show: this.isShowFechaOperacionBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.creation_date'), value: 'fecha-registro', show: this.isShowFechaRegistroBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.total_outstanding_amount'), value: 'total-pagar', show: this.isShowTotalPagarBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.total_executable_amount'), value: 'total-ejecutable', show: this.isShowTotalEjecutableBorrador
          }, {
            text: this.$t('drafts.drafts_entity_table.currency'), value: 'divisa', show: this.isShowDivisaBorrador
          }
        ]
      }
      // Si el usuario sólo tiene un servicio, quitamos el checkbox de servicios
      if (this.optionsFilterService.length < 2) {
        this.columns.splice(0, 1)
      }
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
  .ods-dropdown {
    display: flex;
}
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
